import { Center, Flex, Text } from "@chakra-ui/react";
import { RiDirectionLine } from "@remixicon/react";

import { RouterLinkButton } from "@/common/components/RouterLinkButton";

export default function InvalidRoute() {
  return (
    <Center flexDirection="column" minHeight="100vh" padding="4" width="100%">
      <Flex align="center" direction="column" gap={6}>
        <RiDirectionLine size={80} />
        <Text
          fontSize="md"
          maxW="2xs"
          sx={{ textWrap: "balance" }}
          textAlign="center"
        >
          We couldn&apos;t find the page you were looking for.
        </Text>
        <RouterLinkButton to="/" variant="outline">
          Go back home
        </RouterLinkButton>
      </Flex>
    </Center>
  );
}
